import React, { useEffect, useState } from "react";
import { useCommunityDetails, useCommunityOrderStats } from "./store";
import { Tab, Tabs } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import SoftBadge from "modules/common/SoftBadge";
import PaginationDiv from "modules/pagination/PaginationDiv";
import { fourPlaceHolder, isDownloadDisabled } from "modules/utilities/utility";
import BulkAddOrder from "modules/traya_community/BulkAddOrder";
import { useAllCommunities } from "pages/store";
import xlsx from "json-as-xlsx";
import CommunityStatsTable from "./CommunityStatsTable";
import OrderStatsTable from "./OrderStatsTable";
import NoData from "assets/svgs/no_data/NoData";

function CommunityPage() {
  const navigate = useNavigate();
  const {
    fetchCommunityOrderStats,
    communityDownloadData,
    statsLoading,
    communityOrderStats,
    fetchCommunityDownload,
  } = useCommunityOrderStats();
  const { communityDetails, isLoading, fetchCommunityDetails } =
    useCommunityDetails();
  const { communityData, fetchAllCommunities } = useAllCommunities();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");
  const count = searchParams.get("count");
  const name = searchParams.get("name");
  const [communityDetail, setCommunityDetail] = useState();
  const [orderStats, setOrderStats] = useState();
  const [page, newPage] = useState(1);

  useEffect(() => {
    fetchAllCommunities();
  }, []);

  useEffect(() => {
    fetchCommunityDetails(id, page);
    fetchCommunityDownload(id);
    fetchCommunityOrderStats(id);
  }, [id, page]);

  useEffect(() => {
    setCommunityDetail(communityDetails[0]?.customerDetails);
  }, [communityDetails]);

  useEffect(() => {
    setOrderStats(communityOrderStats[0]?.communityStats);
  }, [communityOrderStats]);

  const handleDownload = () => {
    if (!communityData) {
      message.error("Some Error Occured While Downloading Records");
    } else {
      const memberDetailsSheet = {
        sheet: "Member Details",
        columns: [
          { label: "Name", value: "first_name" },
          { label: "Gender", value: "gender" },
          { label: "Phone Number", value: "phone_number" },
          { label: "Email", value: "email" },
          {
            label: "Created At",
            value: (row) => moment(row.created_at).format("DD/MM/YYYY"),
          },
        ],
        content: communityDownloadData,
      };

      const orderStatsSheet = {
        sheet: "Order Stats",
        columns: [
          { label: "No. Of Orders Placed", value: "type" },
          { label: "Number of Cxs", value: "count" },
        ],
        content: orderStats,
      };

      const data = [memberDetailsSheet, orderStatsSheet];

      const currentDate = new Date().toISOString().slice(0, 10); // Get the current date in "YYYY-MM-DD" format
      const currentTime = new Date().toLocaleTimeString().replace(/:/g, "--"); // Get the current time in "HH-MM-SS" format

      let settings = {
        fileName: `${name} Member Details_${currentDate}_${currentTime}`,
        extraLength: 3,
        writeMode: "writeFile",
        writeOptions: {},
      };
      xlsx(data, settings);
      // message.success("File Downloaded Successfully");
    }
  };

  return (
    <div className="card">
      <div className="mb-1 p-3 shadow-sm">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex">
            <div
              onClick={() => {
                navigate(`/community`);
              }}
              className="cursor-pointer me-3"
            >
              <SoftBadge bg="primary" className="fs-1">
                Back
              </SoftBadge>
            </div>
            <div className="mb-0 fs-1 fw-bold shadow-sm border rounded px-2">{name}</div>
          </div>
          <div className="d-flex gap-2">
            <BulkAddOrder />
            {!isDownloadDisabled && <button className="btn btn-primary" onClick={handleDownload}>
              Download
            </button>}
            <div className="fs-1 shadow p-1 px-2 text-primary border rounded fw-bold">
              Member Count :<span className="text-danger"> {count}</span>
            </div>
          </div>
        </div>
      </div>
      <Tabs
        variant="pills"
        defaultActiveKey="members"
        id="uncontrolled-tab-example"
        className="mb-3 p-3"
      >
        <Tab eventKey="members" title="Member Details">
          <div className="shadow mt-n2">
            {isLoading ? (
              fourPlaceHolder()
            ) : communityDetail?.length ? (
              <CommunityStatsTable data={communityDetail} />
            ) : (
              <div className="text-center border rounded">
                Data is not Available <NoData />
              </div>
            )}
            <PaginationDiv
              paginationData={{
                pageCount: communityDetails?.[0]?.communityStats
                  ? Math.ceil(communityDetails?.[0]?.communityStats / 10)
                  : 1,
                page: page,
              }}
              newPage={newPage}
            />
          </div>
        </Tab>
        <Tab eventKey="stats" title="Order Stats">
          <div className="card p-3 mt-n3">
            {statsLoading ? (
              fourPlaceHolder()
            ) : orderStats?.length ? (
              <OrderStatsTable data={orderStats} />
            ) : (
              <div className="text-center border rounded">
                Data Is not available in Table <NoData />
              </div>
            )}
          </div>
        </Tab>
      </Tabs>
    </div>
  );
}

export default CommunityPage;
